// Location-based data for Bond Collective operations platform

export const locations = [
  'All Locations',
  '55 Broadway',
  '60 Broad', 
  'East Austin',
  'Greenpoint',
  'Vinegar Hill',
  'Bushwick',
  'Center City',
  'Market Street'
];

export const locationDetails = {
  '55 Broadway': {
    city: 'New York, NY',
    address: '55 Broadway, New York, NY 10006',
    floors: [20, 21, 22, 23],
    manager: 'Sarah Johnson'
  },
  '60 Broad': {
    city: 'New York, NY', 
    address: '60 Broad St, New York, NY 10004',
    floors: [15, 16, 17],
    manager: 'Michael Chen'
  },
  'East Austin': {
    city: 'Austin, TX',
    address: '1600 E 6th St, Austin, TX 78702',
    floors: [1, 2, 3],
    manager: 'Lisa Rodriguez'
  },
  'Greenpoint': {
    city: 'Brooklyn, NY',
    address: '1 Freeman Alley, Brooklyn, NY 11222',
    floors: [2, 3, 4],
    manager: 'David Park'
  },
  'Vinegar Hill': {
    city: 'Brooklyn, NY',
    address: '99 Bridge St, Brooklyn, NY 11201',
    floors: [1, 2],
    manager: 'Emma Wilson'
  },
  'Bushwick': {
    city: 'Brooklyn, NY',
    address: '123 Johnson Ave, Brooklyn, NY 11206',
    floors: [1, 2, 3],
    manager: 'Carlos Martinez'
  },
  'Center City': {
    city: 'Philadelphia, PA',
    address: '1500 Market St, Philadelphia, PA 19102',
    floors: [10, 11, 12],
    manager: 'Amanda Thompson'
  },
  'Market Street': {
    city: 'Philadelphia, PA',
    address: '1234 Market St, Philadelphia, PA 19107',
    floors: [5, 6],
    manager: 'Robert Davis'
  }
};

// Enhanced office data with marketed vs signed rates, lease terms, and start dates
export const enhancedOfficeData = [
  // 55 Broadway
  { 
    id: 'bc-55b-2001', 
    location: '55 Broadway', 
    officeNumber: '2001', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'TechCorp Solutions', 
    desks: 1, 
    floor: 20, 
    windowed: false, 
    marketedRates: {
      monthly: 3500,
      sixMonth: 3325,
      twelveMonth: 3150
    },
    signedRate: 3200, // Negotiated rate
    leaseInfo: {
      termMonths: 12,
      startDate: '2024-01-01',
      endDate: '2024-12-31'
    },
    oldRate: 3200,
    contacts: [
      {
        id: '1',
        name: 'John Smith',
        email: 'john.smith@techcorp.com',
        phone: '+1 (555) 123-4567',
        role: 'CEO',
        isPrimary: true
      }
    ]
  },
  { 
    id: 'bc-55b-2002', 
    location: '55 Broadway', 
    officeNumber: '2002', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'Utility', 
    desks: 7, 
    floor: 20, 
    windowed: true, 
    marketedRates: {
      monthly: 5625,
      sixMonth: 5344,
      twelveMonth: 5063
    },
    signedRate: 5344, // 6-month rate
    leaseInfo: {
      termMonths: 6,
      startDate: '2024-03-01',
      endDate: '2024-08-31'
    },
    oldRate: 5200 
  },
  { 
    id: 'bc-55b-2003', 
    location: '55 Broadway', 
    officeNumber: '2003', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'Kadena', 
    desks: 7, 
    floor: 20, 
    windowed: true, 
    marketedRates: {
      monthly: 5625,
      sixMonth: 5344,
      twelveMonth: 5063
    },
    signedRate: 5000, // Negotiated below 12-month rate
    leaseInfo: {
      termMonths: 24,
      startDate: '2023-12-01',
      endDate: '2025-11-30'
    },
    oldRate: 5200 
  },
  { 
    id: 'bc-55b-2004', 
    location: '55 Broadway', 
    officeNumber: '2004', 
    type: 'Private Office', 
    status: 'UNAVAILABLE', 
    tenant: 'Bond Staff', 
    desks: 3, 
    floor: 20, 
    windowed: true, 
    marketedRates: {
      monthly: 1825,
      sixMonth: 1734,
      twelveMonth: 1644
    },
    signedRate: 0, // Internal use
    leaseInfo: {
      termMonths: 0,
      startDate: null,
      endDate: null
    },
    oldRate: 1825 
  },
  { 
    id: 'bc-55b-2005', 
    location: '55 Broadway', 
    officeNumber: '2005', 
    type: 'Private Office', 
    status: 'PENDING', 
    tenant: 'Noble Ksome (Agreement Sent)', 
    desks: 1, 
    floor: 20, 
    windowed: false, 
    marketedRates: {
      monthly: 1700,
      sixMonth: 1615,
      twelveMonth: 1530
    },
    signedRate: 1615, // Expected 6-month rate
    leaseInfo: {
      termMonths: 6,
      startDate: '2024-02-01', // Future start
      endDate: '2024-07-31'
    },
    oldRate: 1550 
  },
  { 
    id: 'bc-55b-2006', 
    location: '55 Broadway', 
    officeNumber: '2006', 
    type: 'Private Office', 
    status: 'VACANT', 
    tenant: null, 
    desks: 3, 
    floor: 20, 
    windowed: true, 
    marketedRates: {
      monthly: 1825,
      sixMonth: 1734,
      twelveMonth: 1644
    },
    signedRate: null,
    leaseInfo: {
      termMonths: null,
      startDate: null,
      endDate: null
    },
    oldRate: 1650 
  },
  { 
    id: 'bc-55b-2007', 
    location: '55 Broadway', 
    officeNumber: '2007', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'MatrixG - Alleged', 
    desks: 1, 
    floor: 20, 
    windowed: false, 
    marketedRates: {
      monthly: 700,
      sixMonth: 665,
      twelveMonth: 630
    },
    signedRate: 650, // Negotiated rate
    leaseInfo: {
      termMonths: 3,
      startDate: '2024-01-15',
      endDate: '2024-04-15'
    },
    oldRate: 650 
  },
  { 
    id: 'bc-55b-2008', 
    location: '55 Broadway', 
    officeNumber: '2008', 
    type: 'Private Office', 
    status: 'VACANT', 
    tenant: null, 
    desks: 3, 
    floor: 20, 
    windowed: true, 
    marketedRates: {
      monthly: 1825,
      sixMonth: 1734,
      twelveMonth: 1644
    },
    signedRate: null,
    leaseInfo: {
      termMonths: null,
      startDate: null,
      endDate: null
    },
    oldRate: 1650 
  },
  { 
    id: 'bc-55b-2009', 
    location: '55 Broadway', 
    officeNumber: '2009', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'Izen Mechanism LLC', 
    desks: 8, 
    floor: 20, 
    windowed: true, 
    marketedRates: {
      monthly: 4450,
      sixMonth: 4228,
      twelveMonth: 4005
    },
    signedRate: 4005, // 12-month rate
    leaseInfo: {
      termMonths: 12,
      startDate: '2023-10-01',
      endDate: '2024-09-30'
    },
    oldRate: 4100 
  },

  // 60 Broad
  { 
    id: 'bc-60b-1501', 
    location: '60 Broad', 
    officeNumber: '1501', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'Design Studio Inc', 
    desks: 4, 
    floor: 15, 
    windowed: true, 
    marketedRates: {
      monthly: 2800,
      sixMonth: 2660,
      twelveMonth: 2520
    },
    signedRate: 2660,
    leaseInfo: {
      termMonths: 6,
      startDate: '2023-11-01',
      endDate: '2024-04-30'
    },
    oldRate: 2600 
  },
  { 
    id: 'bc-60b-1502', 
    location: '60 Broad', 
    officeNumber: '1502', 
    type: 'Private Office', 
    status: 'VACANT', 
    tenant: null, 
    desks: 2, 
    floor: 15, 
    windowed: false, 
    marketedRates: {
      monthly: 1400,
      sixMonth: 1330,
      twelveMonth: 1260
    },
    signedRate: null,
    leaseInfo: {
      termMonths: null,
      startDate: null,
      endDate: null
    },
    oldRate: 1300 
  },
  { 
    id: 'bc-60b-1503', 
    location: '60 Broad', 
    officeNumber: '1503', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'Marketing Solutions', 
    desks: 6, 
    floor: 15, 
    windowed: true, 
    marketedRates: {
      monthly: 4200,
      sixMonth: 3990,
      twelveMonth: 3780
    },
    signedRate: 3900, // Custom negotiated rate
    leaseInfo: {
      termMonths: 18,
      startDate: '2023-08-01',
      endDate: '2025-01-31'
    },
    oldRate: 3900 
  },

  // East Austin
  { 
    id: 'bc-ea-101', 
    location: 'East Austin', 
    officeNumber: '101', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'Austin Startups', 
    desks: 3, 
    floor: 1, 
    windowed: true, 
    marketedRates: {
      monthly: 1800,
      sixMonth: 1710,
      twelveMonth: 1620
    },
    signedRate: 1710,
    leaseInfo: {
      termMonths: 6,
      startDate: '2023-12-01',
      endDate: '2024-05-31'
    },
    oldRate: 1650 
  },
  { 
    id: 'bc-ea-102', 
    location: 'East Austin', 
    officeNumber: '102', 
    type: 'Private Office', 
    status: 'VACANT', 
    tenant: null, 
    desks: 2, 
    floor: 1, 
    windowed: false, 
    marketedRates: {
      monthly: 1200,
      sixMonth: 1140,
      twelveMonth: 1080
    },
    signedRate: null,
    leaseInfo: {
      termMonths: null,
      startDate: null,
      endDate: null
    },
    oldRate: 1100 
  },

  // Sample offices for other locations with similar structure...
  { 
    id: 'bc-gp-201', 
    location: 'Greenpoint', 
    officeNumber: '201', 
    type: 'Private Office', 
    status: 'LEASED', 
    tenant: 'Brooklyn Creatives', 
    desks: 5, 
    floor: 2, 
    windowed: true, 
    marketedRates: {
      monthly: 3000,
      sixMonth: 2850,
      twelveMonth: 2700
    },
    signedRate: 2850,
    leaseInfo: {
      termMonths: 6,
      startDate: '2024-01-01',
      endDate: '2024-06-30'
    },
    oldRate: 2750 
  },
  { 
    id: 'bc-gp-202', 
    location: 'Greenpoint', 
    officeNumber: '202', 
    type: 'Private Office', 
    status: 'VACANT', 
    tenant: null, 
    desks: 3, 
    floor: 2, 
    windowed: false, 
    marketedRates: {
      monthly: 1800,
      sixMonth: 1710,
      twelveMonth: 1620
    },
    signedRate: null,
    leaseInfo: {
      termMonths: null,
      startDate: null,
      endDate: null
    },
    oldRate: 1650 
  }
];

// Helper function to calculate current revenue based on signed rate (not marketed rate)
export const getCurrentRevenue = (office) => {
  if (office.status !== 'LEASED') return 0;
  return office.signedRate || 0;
};

// Helper function to calculate lease end date
export const calculateLeaseEndDate = (startDate, termMonths) => {
  if (!startDate || !termMonths) return null;
  const start = new Date(startDate);
  const end = new Date(start);
  end.setMonth(end.getMonth() + termMonths);
  return end.toISOString().split('T')[0];
};

// Helper function to get lease status (current, upcoming, expired)
export const getLeaseStatus = (office) => {
  if (!office.leaseInfo?.startDate || !office.leaseInfo?.endDate) return 'No lease';
  
  const today = new Date();
  const startDate = new Date(office.leaseInfo.startDate);
  const endDate = new Date(office.leaseInfo.endDate);
  
  if (today < startDate) return 'Upcoming';
  if (today > endDate) return 'Expired';
  return 'Active';
};

// Helper function to calculate days until lease end
export const getDaysUntilLeaseEnd = (office) => {
  if (!office.leaseInfo?.endDate) return null;
  
  const today = new Date();
  const endDate = new Date(office.leaseInfo.endDate);
  const diffTime = endDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays;
};

// Generate member data by location
export const generateMembersByLocation = () => {
  const members = [];
  
  Object.keys(locationDetails).forEach(location => {
    const memberCount = Math.floor(Math.random() * 15) + 10; // 10-25 members per location
    
    for (let i = 0; i < memberCount; i++) {
      const companyName = generateTenantName();
      const membershipTypes = ['Premium', 'Standard', 'Basic'];
      
      members.push({
        id: `${location}-${i + 1}`,
        location,
        companyName,
        contactName: generateContactName(),
        contactEmail: generateEmail(companyName),
        contactPhone: generatePhone(),
        membershipType: membershipTypes[Math.floor(Math.random() * membershipTypes.length)],
        employees: generateEmployees(companyName, Math.floor(Math.random() * 8) + 2)
      });
    }
  });
  
  return members;
};

const generateTenantName = () => {
  const companyNames = [
    'TechCorp Solutions', 'Design Studio Inc', 'Marketing Pro LLC', 'Consulting Experts',
    'Finance Solutions', 'Legal Associates', 'Creative Agency', 'Software Development Co',
    'Digital Marketing Hub', 'Innovation Labs', 'Strategy Partners', 'Growth Ventures',
    'Media Collective', 'Data Analytics Co', 'Product Design Studio', 'Content Creators LLC'
  ];
  return companyNames[Math.floor(Math.random() * companyNames.length)];
};

const generateContactName = () => {
  const firstNames = ['John', 'Sarah', 'Michael', 'Emma', 'David', 'Lisa', 'Robert', 'Amanda', 'Carlos', 'Jessica'];
  const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez'];
  
  return `${firstNames[Math.floor(Math.random() * firstNames.length)]} ${lastNames[Math.floor(Math.random() * lastNames.length)]}`;
};

const generateEmail = (companyName) => {
  const domain = companyName.toLowerCase().replace(/[^a-z0-9]/g, '') + '.com';
  const firstName = generateContactName().split(' ')[0].toLowerCase();
  return `${firstName}@${domain}`;
};

const generatePhone = () => {
  return `+1 (${Math.floor(Math.random() * 900) + 100}) ${Math.floor(Math.random() * 900) + 100}-${Math.floor(Math.random() * 9000) + 1000}`;
};

const generateEmployees = (companyName, count) => {
  const employees = [];
  const roles = ['CEO', 'CTO', 'Developer', 'Designer', 'Marketing Manager', 'Sales Director', 'Operations Manager', 'Consultant'];
  
  for (let i = 0; i < count; i++) {
    const name = generateContactName();
    const email = generateEmail(companyName);
    const role = roles[Math.floor(Math.random() * roles.length)];
    
    employees.push({ name, role, email });
  }
  
  return employees;
};

export const mockMembers = generateMembersByLocation();